import React from "react";
import {Input, Label} from "reactstrap";
import {useTranslation} from "react-i18next";
import {ALL_SYNC_MODULES, SyncModuleKey} from "../helpers/onboardingModules";

interface Props {
    formik: any;
}

const RECOMMENDED: SyncModuleKey[] = ["invoice", "payment"];

const ModuleSelect: React.FC<Props> = ({formik}) => {
    const {t} = useTranslation();
    const selected: SyncModuleKey[] = Array.isArray(formik.values.enabled_sync_modules)
        ? formik.values.enabled_sync_modules
        : [];

    const toggle = (module: SyncModuleKey) => {
        const next = selected.includes(module)
            ? selected.filter((item) => item !== module)
            : [...selected, module];
        formik.setFieldValue("enabled_sync_modules", next);
    };

    const selectRecommended = () => {
        formik.setFieldValue("enabled_sync_modules", [...RECOMMENDED]);
    };

    const selectAll = () => {
        formik.setFieldValue("enabled_sync_modules", [...ALL_SYNC_MODULES]);
    };

    return (
        <React.Fragment>
            <p className="text-muted mb-3">{t("common.setup.modulesHelp")}</p>
            <div className="d-flex flex-wrap gap-2 mb-3">
                <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary"
                    onClick={selectRecommended}
                >
                    {t("common.setup.selectRecommended")}
                </button>
                <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary"
                    onClick={selectAll}
                >
                    {t("common.setup.selectAllModules")}
                </button>
            </div>
            <div className="d-flex flex-column gap-2">
                {ALL_SYNC_MODULES.map((module) => {
                    const isSelected = selected.includes(module);
                    const isRecommended = RECOMMENDED.includes(module);

                    return (
                        <Label
                            key={module}
                            className={[
                                "d-flex align-items-start gap-2 p-3 rounded mb-0",
                                isSelected ? "border border-2" : "border",
                            ].join(" ")}
                            style={{
                                cursor: "pointer",
                                borderColor: isSelected ? "#e85d04" : undefined,
                                backgroundColor: isSelected ? "rgba(232, 93, 4, 0.06)" : undefined,
                            }}
                        >
                            <Input
                                type="checkbox"
                                className="mt-1"
                                checked={isSelected}
                                onChange={() => toggle(module)}
                            />
                            <span className="flex-grow-1">
                                <span className="d-flex align-items-center gap-2 flex-wrap">
                                    <strong className="d-block mb-0">{t(`common.setup.module_${module}`)}</strong>
                                    {isRecommended ? (
                                        <span className="badge bg-secondary">{t("common.setup.recommended")}</span>
                                    ) : null}
                                </span>
                                <small className="text-muted d-block mt-1">
                                    {t(`common.setup.module_${module}_help`)}
                                </small>
                            </span>
                        </Label>
                    );
                })}
            </div>
            {formik.errors?.enabled_sync_modules && (
                <div className="text-danger small mt-2">{String(formik.errors.enabled_sync_modules)}</div>
            )}
            <p className="text-muted small mt-3 mb-0">{t("common.setup.modulesLaterHint")}</p>
        </React.Fragment>
    );
};

export default ModuleSelect;
